
import './PersonalActivities.css';

const PersonalActivities = ()=>{
    return(
        <>
 
        {/* START PersonalActivitiesMain */}
        <section className="personalActivitiesMain" id='PersonalRental'>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="headPersonalActivities">
                        <h2>Rental insurance coverage for personal or work activities</h2>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                    <div className='personalActivitiesLeft'>
                        <h3>Coverage & Protection for rental fleets</h3>
                        <p>Designed specifically for personal use and leisure rentals, other than generating income.</p>
                        <small>Covers renters for:</small>
                        <ul>
                            <li>
                                <img width="24px" height="24px" src="/img/rentshield/personal_rentals_1.svg" alt="icon"/>
                                <span>Vacations or weekend trips</span> 
                            </li>
                            <li>
                                <img width="24px" height="24px" src="/img/rentshield/personal_rentals_2.svg" alt="icon"/>
                                <span>Visiting family or friends</span> 
                            </li>
                            <li>
                                <img width="24px" height="24px" src="/img/rentshield/gigRentals_2.svg" alt="icon"/>
                                <span>Running errands</span> 
                            </li>
                            <li>
                                <img width="24px" height="24px" src="/img/rentshield/personal_rentals_4.svg" alt="icon"/>
                                <span>Corporate work travel (excludes delivery and ride-hailing) </span> 
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                    <div className='personalActivitiesRight'>
                        <figure>
                            <img className="img-fluid" src="/img/rentshield/boostEarnings_11.webp" alt="Coverage & Protection for rental fleets"/>
                        </figure>
                    </div>
                </div>
            </div>
        </div>
        </section>
        {/* END PersonalActivitiesMain */}

        {/* START rideShareMain */}
        <section className="rideShareMain" id='GigRental'>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="headRideShare">
                                <h2>Rental insurance coverage for ride share & delivery drivers</h2>
                            </div>
                        </div>
                    </div>

                    <div className='rideShareOuter'>
                        <div className='row justify-content-center align-items-center'>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                <div className='rideShareLeft'>
                                    <figure>
                                        <img className="img-fluid" src="/img/rentshield/rideShare_1.jpg" alt="rent id"/>
                                    </figure>
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                <div className='rideShareRight'>
                                    <p>Our exclusive insurance solution allows you to confidently rent your vehicles to drivers 
                                    on platforms like Uber, Lyft, Uber Eats, Instacart, DoorDash, and Grubhub.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='rideShareOuter rideShareOuter_2'>
                        <div className='row justify-content-center align-items-center'>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                <div className='rideShareRight'>
                                    <p>Our policy specifically covers vehicles during off-platform times—when the app is closed, 
                                    and the driver is not engaged in ride share or delivery activities.</p>
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                <div className='rideShareLeft'>
                                    <figure>
                                        <img className="img-fluid" src="/img/rentshield/rideShare_2.jpg" alt="rent id"/>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className='rideShareOuter rideShareOuter_3'>
                        <div className='row justify-content-center align-items-center'>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                <div className='rideShareLeft'>
                                    <figure>
                                        <img className="img-fluid" src="/img/rentshield/rideShare_3.jpg" alt="rent id"/>
                                    </figure>
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                <div className='rideShareRight'>
                                    <p>This protection ensures your vehicle is safeguarded during those in-between moments 
                                        while tapping into a highly lucrative market.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
              </section>
        {/* END rideShareMain */}

        </>
    )
}

export default PersonalActivities;